export default {
  init() {
    // first location breaker only
    const breaker = document.querySelector('.ms-breaker');

    if (breaker) {
      breaker.classList.add('ms-breaker--first');
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/breaker.js